import apiClient from '../utils/apiClient';

/**
 * Issue report API (admin: list all, approve, reject)
 * Theo docs ISSUE_REPORT_INTEGRATION.md
 */
export const issueReportAPI = {
  /**
   * [Admin] Danh sách tất cả báo cáo sự cố
   */
  getIssueReports: async (params = {}) => {
    return await apiClient.get({
      url: '/issue-reports',
      params,
    });
  },

  /**
   * Chi tiết một báo cáo
   */
  getIssueReportById: async (id) => {
    return await apiClient.get({
      url: `/issue-reports/${id}`,
    });
  },

  /**
   * [Admin] Duyệt báo cáo (body: { bonus_percent?: number })
   */
  approveIssueReport: async (id, data = {}) => {
    return await apiClient.put({
      url: `/issue-reports/${id}/approve`,
      data,
    });
  },

  /**
   * [Admin] Từ chối báo cáo (body: { reason?: string })
   */
  rejectIssueReport: async (id, data = {}) => {
    return await apiClient.put({
      url: `/issue-reports/${id}/reject`,
      data,
    });
  },
};
